import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "~/css/TracksPopular.less";
import TrackBox from "./TrackBox";

const TracksPopularLastWeek = ({ tracks }) => (
  <Row className="totd-featured-box popular-tracks-last-week" id="popular">
    <Col xs={12} style={{ marginBottom: 20 }}>
      <h2 className="page-header">
        <FontAwesomeIcon icon="thumbs-up" className="thumbs-up" />
        Popular Tracks from Last Week
      </h2>
    </Col>
    <Col xs={12}>
      <Row>
        {tracks &&
          tracks.map((track) => {
            return (
              <Col xs={12} sm={6} md={6} className="popularItem" key={track.id}>
                <span className="popularItemImage">
                  <TrackBox allowPlay={false} track={track} showTitle={false} showDate={false} />
                </span>
                <span>
                  "<Link to={`/${track.id}`}>{track.title}</Link>" {track.artist}
                </span>
              </Col>
            );
          })}
      </Row>
    </Col>
  </Row>
);

export default TracksPopularLastWeek;
